import React from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import { createStructuredSelector } from 'reselect';
import { FormattedMessage } from 'react-intl';
import BlockUi from 'react-block-ui';
import { Helmet } from 'react-helmet';
import GuestBox from '../../components/GuestBox';
import Link from '../../components/Link';
import ButtonField from '../../components/ButtonField';
import { createLoadingSelector, tokenSelector } from '../Main/reducer';
import { LOGIN_REQUEST, login } from './actions';
import { emailValidator } from '../../utils/validator';
import logo from '../../assets/vb-logo.png';
import TextField from '../../components/LogingTextField';
import Icon from '@mdi/react';
import { mdiEye, mdiEyeOff } from '@mdi/js';
import Wrapper from './components/Wrapper';

class LoginPage extends React.Component {
  state = {
    showPassword: false,
  };

  togglePasswordVisibility = () => {
    this.setState((prevState) => ({ showPassword: !prevState.showPassword }));
  };

  render() {
    const { history, loading, login, handleSubmit } = this.props;
    const { showPassword } = this.state;

    return (
      <BlockUi blocking={loading}>
        <Helmet>
          <title>Login | VoiceboxMD Web</title>
          <meta
            name="description"
            content="Log in to create secure notes using speech to text recognition."
          />
        </Helmet>
        <GuestBox>
          <img
            src="./favicon.ico"
            alt="VoiceboxMD Logo"
            style={{ width: '25px', marginBottom: '1rem' }}
          />
          <img
            src={logo}
            alt="VoiceboxMD Logo"
            style={{ width: '150px', marginBottom: '1rem' }}
          />
          <div className="title mb-4">
            <FormattedMessage id="LoginPage.signIn" />
          </div>
          <FormattedMessage id="LoginPage.email">
            {(msg) => (
              <Field
                name="email"
                component={TextField}
                placeholder={msg}
                className="mb-4"
                type="email"
              />
            )}
          </FormattedMessage>
          <FormattedMessage id="LoginPage.password">
            {(msg) => (
              <Wrapper>
                <Field
                  name="password"
                  component={TextField}
                  type={showPassword ? 'text' : 'password'}
                  placeholder={msg}
                  className="mb-4"
                  onEnter={handleSubmit(login)}
                  style={{
                    paddingRight: '40px',
                    width: '100%',
                  }}
                />
                <Icon
                  path={showPassword ? mdiEyeOff : mdiEye}
                  size={0.8}
                  color="#6c757d"
                  style={{
                    position: 'absolute',
                    right: '10px',
                    cursor: 'pointer',
                    top: '50%',
                    transform: 'translateY(-50%)',
                  }}
                  onClick={this.togglePasswordVisibility}
                  title={showPassword ? 'Hide password' : 'Show password'}
                />
              </Wrapper>
            )}
          </FormattedMessage>
          <ButtonField
            className="mb-3"
            loading={loading}
            onClick={handleSubmit(login)}
          >
            <FormattedMessage id="LoginPage.signInSecondary" />
          </ButtonField>
          <Link bold onClick={() => history.push('/forgot')} className="forgot">
            <FormattedMessage id="LoginPage.forgot" />
          </Link>
        </GuestBox>
      </BlockUi>
    );
  }
}

LoginPage = reduxForm({
  form: 'login',
  validate: (values) => {
    const errors = {};
    if (!values.email) {
      errors.email = 'required';
    } else if (!emailValidator(values.email)) {
      errors.email = 'invalidEmail';
    }
    if (!values.password) {
      errors.password = 'required';
    }
    return errors;
  },
})(LoginPage);

LoginPage = connect(
  createStructuredSelector({
    token: tokenSelector,
    loading: createLoadingSelector([LOGIN_REQUEST]),
  }),
  { login }
)(LoginPage);

export default LoginPage;
